import { API_G_020_JUCHU_ENTRY } from '@/constants/api';
import axios from '@/plugins/axios';
import { removeBlankOrNullOrZero } from '@/utils/utils';
import type { Module } from 'vuex';

const g_020: Module<unknown, unknown> = {
  namespaced: true,
  state() {
    return {};
  },
  mutations: {},
  getters: {},
  actions: {
    async getJuchuEntry(_ctx, params) {
      try {
        const res = await axios({
          url: API_G_020_JUCHU_ENTRY,
          method: 'GET',
          params: removeBlankOrNullOrZero(params),
        });

        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api getJuchuEntry error.');
        console.log(err);
        return await Promise.reject(err);
      }
    },
    async postJuchuEntry(_ctx, requestData) {
      try {
        const res = await axios({
          url: API_G_020_JUCHU_ENTRY,
          data: {
            requestData,
          },
          method: 'POST',
        });
        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api postJuchuEntry error.');
        console.log(err);
      }
    },
    async getJuchuEntryItem(_ctx, params) {
      try {
        const { juchuEntryJigyoshoCd, juchuEntryYmd, tokuisakiHatchuNo } =
          params;

        const res = await axios({
          url: `${API_G_020_JUCHU_ENTRY}/${juchuEntryJigyoshoCd}/${juchuEntryYmd}/${tokuisakiHatchuNo}`,
          method: 'GET',
          params,
        });

        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api getJuchuEntryItem error.');
        console.log(err);
        return await Promise.reject(err);
      }
    },
    async putJuchuEntryItem(_ctx, requestData) {
      try {
        const { juchuEntryJigyoshoCd, juchuEntryYmd, tokuisakiHatchuNo } =
          requestData.juchuData;

        const res = await axios({
          url: `${API_G_020_JUCHU_ENTRY}/${juchuEntryJigyoshoCd}/${juchuEntryYmd}/${tokuisakiHatchuNo}`,
          data: {
            requestData,
          },
          method: 'PUT',
        });
        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api putJuchuEntryItem error.');
        console.log(err);
      }
    },
    async deleteJuchuEntryItem(_ctx, params) {
      try {
        const { juchuEntryJigyoshoCd, juchuEntryYmd, tokuisakiHatchuNo } =
          params;

        const res = await axios({
          url: `${API_G_020_JUCHU_ENTRY}/${juchuEntryJigyoshoCd}/${juchuEntryYmd}/${tokuisakiHatchuNo}`,
          params,
          method: 'DELETE',
        });

        return await Promise.resolve(res);
      } catch (err) {
        console.log('call api deleteJuchuEntryItem error.');
        console.log(err);
      }
    },
  },
};

export default g_020;
